import { Grid } from "@mui/material";
import { NumberFormatInput } from "components/FormControls/NumberFormatInput";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { limitsOptions } from "components/Layout/Campaign/utils/utils";
import { useMessage } from "hooks/intl";
import { memo } from "react";

import { LimitsPathPrefixes, SelectedLimitType } from "types/campaigns";

const getIntervalTypeLabel = (type: LimitsPathPrefixes): string => {
  switch (type) {
    case "executions":
      return "automationTriggersLimitation";
    case "executionsPerMember":
      return "automationCompletionPerMember";
    case "points":
      return "unitsIssuedByTheAutomation";
    case "pointsPerMember":
      return "unitsIssuedPerMember";
    default:
      return "";
  }
};

const getValueLabel = (type: LimitsPathPrefixes): string => {
  switch (type) {
    case "executions":
    case "executionsPerMember":
      return "triggersLimit";
    case "points":
    case "pointsPerMember":
      return "unitsLimit";
    default:
      return "";
  }
};

interface Props {
  isEditMode?: boolean;
  name: LimitsPathPrefixes;
  status?: any;
  value?: SelectedLimitType;
  "data-test-id": string;
}

export const Limit = memo(
  ({ name, value, "data-test-id": dataTestId }: Props) => {
    const { message } = useMessage();

    const isUnlimitedSelected = value && value.interval.type === "noLimit";
    return (
      <>
        <Grid container spacing={12}>
          <Grid xs={6} item>
            <SelectInput
              width="100%"
              data-test-id={`${dataTestId}-select`}
              helperText={
                name === "executions"
                  ? message({
                      id: "numberOfTimesTheCampaignIsTriggered",
                    })
                  : undefined
              }
              items={limitsOptions.map(
                (
                  option,
                ): {
                  id: string;
                  label: string;
                } => ({
                  id: option.value,
                  label: message({ id: option.label }),
                }),
              )}
              label={message({
                id: getIntervalTypeLabel(name),
              })}
              name={`limits.${name}.interval.type`}
            />
          </Grid>
          {!isUnlimitedSelected && (
            <Grid xs={6} item>
              <NumberFormatInput
                data-test-id={`${dataTestId}-value`}
                label={
                  <RequiredFieldLabel
                    text={message({
                      id: getValueLabel(name),
                    })}
                  />
                }
                name={`limits.${name}.value`}
              />
            </Grid>
          )}
        </Grid>
      </>
    );
  },
);
